<template>
    <ul class="menu-nav">

        <router-link to="/create-report" v-slot="{ href, navigate, isActive, isExactActive }">
            <li :class="isExact(isActive, isExactActive)" aria-haspopup="true" class="menu-item" data-menu-toggle="hover"
                @click="initCreateReport">
                <a :href="href" @click="navigate" class="menu-link">
                    <span class="menu-text"> Create </span>
                </a>
            </li>
        </router-link>

       <router-link to="/analysis" v-slot="{ href, navigate, isActive, isExactActive }">
          <li :class="isExact(isActive, isExactActive)" aria-haspopup="true" class="menu-item" data-menu-toggle="hover"
               @click="initAnalysis">
             <a :href="href" @click="navigate" class="menu-link">
                <span class="menu-text"> Analysis </span>
             </a>
          </li>
       </router-link>

       <router-link to="/my-reports" v-slot="{ href, navigate, isActive, isExactActive }">
          <li :class="isExact(isActive, isExactActive)" aria-haspopup="true" class="menu-item" data-menu-toggle="hover">
             <a :href="href" @click="navigate" class="menu-link">
                <span class="menu-text"> My Report </span>
             </a>
          </li>
       </router-link>

        <router-link to="/my-analysis" v-slot="{ href, navigate, isActive, isExactActive }">
            <li :class="isExact(isActive, isExactActive)" aria-haspopup="true" class="menu-item" data-menu-toggle="hover">
                <a :href="href" @click="navigate" class="menu-link">
                    <span class="menu-text"> My Analysis </span>
                </a>
            </li>
        </router-link>

    </ul>
</template>

<script>

   import {CHANGE_COMPONENT} from '../../../core/store/modules/report';

   export default {
      name: "KTMenu",
      methods: {
         isExact(isActive, isExactActive) {
            return [
               isActive && 'menu-item-active',
               isExactActive && 'menu-item-active'
            ]
         },
         initCreateReport() {
            this.$store.dispatch(CHANGE_COMPONENT, 'appReportInit');
         },
         initAnalysis() {
            this.$store.dispatch(CHANGE_COMPONENT, 'appAnalysisInit');
         }
      },
   };
</script>